import { cn } from '@utima/ui';

type StatusBadgeProps = {
  label: string;
  tone?: 'default' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md';
};

const toneStyles = {
  default: 'bg-muted text-foreground',
  success:
    'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  warning:
    'bg-yellow-100 text-yellow-900 dark:bg-yellow-900/40 dark:text-yellow-200',
  danger: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  info: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
};

const sizeStyles = {
  sm: 'px-2.5 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm font-semibold',
};

export function StatusBadge({
  label,
  tone = 'default',
  size = 'sm',
}: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        toneStyles[tone],
        sizeStyles[size],
      )}
    >
      {label}
    </span>
  );
}
